import { render, staticRenderFns } from "./PolicyRulesDiff.vue?vue&type=template&id=2bb53012"
import script from "./PolicyRulesDiff.vue?vue&type=script&lang=js"
export * from "./PolicyRulesDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports